var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForestry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "91991697-39CD-4B67-9705-DF1856BB1162") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,9 L14.25,9 L9,1.5 L3.7875,9 L5.25,9 L2.325,13.5 L7.515,13.5 L7.515,16.5 L10.4775,16.5 L10.4775,13.5 L15.75,13.5 L12.75,9 Z M5.0925,12 L8.0175,7.5 L6.66,7.5 L9.0075,4.125 L11.37,7.5 L9.945,7.5 L12.945,12 L5.0925,12 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Projects",
    transform: "translate(-878.000000, -938.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(256.000000, 568.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(48.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    transform: "translate(556.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(16.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AVATAR",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "park_black_24dp"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icon-Color",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestry);
export default __webpack_public_path__ + "static/media/forestry.7e1c6788428f991d4c66c5d856d6a479.svg";
export { ForwardRef as ReactComponent };